import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
	type HttpRestoreExperienceVettingCriteriaItineraryCoveryImageOptions,
	httpRestoreExperienceVettingCriteriaItineraryCoveryImage
} from '@/features/experience-vetting/http/experience-vetting.http.ts'
import { errorHandler } from '@/helpers/utils'
import { QUERY_KEYS } from '@/query-client'

export const useRestoreExperienceVettingCriteriaItineraryCoveryImage = ({
	experienceId,
	itineraryId
}: HttpRestoreExperienceVettingCriteriaItineraryCoveryImageOptions['urlParams']) => {
	const queryClient = useQueryClient()
	return useMutation({
		mutationFn: () =>
			httpRestoreExperienceVettingCriteriaItineraryCoveryImage({
				urlParams: { experienceId, itineraryId },
				params: {
					responseType: 'extended'
				}
			}),
		onError: (error) => {
			errorHandler(error)
		},
		onSuccess: (data) => {
			queryClient.setQueriesData(
				{ queryKey: [QUERY_KEYS.EXPERIENCE_VETTING, experienceId] },
				data
			)
		}
	})
}
